import { store } from '@atredux/store'
import { setIsSeawardModalOpen } from '@atredux/slices/iframeSlice'
import { switchToMigratedIFrame } from '@utils/ModalSwitchUtil'

export async function closeSeawardModal () {
    const state = store.getState()
    if (!state.iframe.isSeawardModalOpen) {
        console.log('ATBase: No modal open in Seaward iFrame.')
        return
    }
    const selectedTool = state.tool.tool
    console.log('ATBase: Closing Modal in Seaward iFrame.')
    store.dispatch(setIsSeawardModalOpen(false))
    if (selectedTool.showMigrated) {
        switchToMigratedIFrame()
    }
}
